/**
 * Switch: the front-desk Referrals tab in the Calendar (PROD-1395). It lists the referrals physicians
 * send and offers a Book action that opens the create-appointment panel. Off by default (UI rules:
 * anything new behind ?x=).
 *
 * Two gates, both must be on:
 *  1. `VITE_REFERRALS` is the build-time kill switch. dev-web.yml sets "true"; prod-web.yml omits it,
 *     so `?x=referrals` does nothing in a prod build.
 *  2. The browser opts in with `?x=referrals` (remembered; `?x=-referrals` opts out).
 * With either off the Calendar shows the same tabs as today. See `src/shared/lib/practice-switches.ts`.
 */
import { isPracticeSwitchOn } from '@/shared/lib/practice-switches'

import { coerceFlag } from './use-clinic-edit-rail-enabled'

/** Whether this build and browser show the Referrals tab in the Calendar. */
export function useReferralsEnabled(): boolean {
  return coerceFlag(import.meta.env.VITE_REFERRALS) && isPracticeSwitchOn('referrals')
}
